import {Component, ViewChild, OnInit} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { WorkOrder } from '@app/model/work-order.model';
import { WorkOrderService } from '@app/services/work-order.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { WorkOrderComponent } from '../work-order/work-order.component';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {
  displayedColumns = ['id', 'nombre', 'estado', 'prioridad','tipo','usuario'/*,'archivo','comentario'*/,'fecha_de_creacion','latitud','longitud','accion'];

  dataSource: MatTableDataSource<WorkOrder>;
  workOrders: WorkOrder[];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  //para una mejora de traer solo la pagina que se esta viendo
//https://medium.com/@proSbeginner/angular-8-pagination-and-sorting-5bcb3c01934e
  ngOnInit(){
    this.workOrderService.getWorkorders().subscribe(values=>{
      this.workOrders = values;
      this.dataSource = new MatTableDataSource(values);
      //this.dataSource.data = values;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    }),error=>console.log('Error al buscar los datos');
  }

  constructor(private workOrderService:WorkOrderService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute) {
  }

  /**
   * Set the paginator and sort after the view init since this component will
   * be able to query its view for the initialized paginator and sort.
   */
  ngAfterViewInit() {
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  redirectToDetails(WorkOrder){
    console.log('redirectToDetails id '+WorkOrder.id);
    const dialogRef = this.dialog.open(WorkOrderComponent, {
      width: '500px',
      minHeight: '1000px'
    });
  }
  redirectToUpdate(id){
    console.log('redirectToUpdate id '+id);
    const dialogRef = this.dialog.open(WorkOrderComponent, {
      width: '500px',
      minHeight: '1000px'
    });
    console.log('redirectToUpdate id '+id);
    dialogRef.afterClosed().subscribe(result => {

    });
  }
  redirectToDelete(WorkOrder){

    console.log('redirectToDelete id '+WorkOrder.id);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '250px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed result '+result);
      if(result){
        console.log('The dialog was closed result SIIII '+result);
        this.workOrderService.eliminarOrdenDeTrabajo(WorkOrder.id).subscribe(value=>{
          this.toastr.success("Nota eliminada Correctamente. ",'Finalizada');
          let index: number = this.workOrders.findIndex(d => d === WorkOrder);
          console.log(this.workOrders.findIndex(d => d === WorkOrder));
          this.workOrders.splice(index,1)
          this.dataSource = new MatTableDataSource<WorkOrder>(this.workOrders);
        }),errror=>{
          this.toastr.error("Error al eliminar la nota. ",'Error');
        };
      }
    });

  }
  openDialog(action,obj) {
    /*
    obj.action = action;
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      width: '250px',
      data:obj
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.event == 'Add'){
        this.addRowData(result.data);
      }else if(result.event == 'Update'){
        this.updateRowData(result.data);
      }else if(result.event == 'Delete'){
        this.deleteRowData(result.data);
      }
    });
    */
  }
}

